export const setTypeUserInQuery = (typeUser: string) => {
    if (typeUser === 'user') {
        return 'user.typeUser=user';
    }
    return '';
};
